import React from 'react'
import { HorizontalLayout, Content, Sidebar, MenuItem } from '../common'
import ReduxStateTab from './redux/ReduxStateTab'
import ReduxActionsTab from './redux/ReduxActionsTab'
import { useSessionPersistedTabs } from '../hooks'

const tabs = [
  { id: 'currentState', label: 'Current state', component: ReduxStateTab },
  { id: 'actions', label: 'Actions', component: ReduxActionsTab },
] as const

const tabIds = tabs.map(tab => tab.id)

const TAB_STORAGE_KEY = 'DevPanel:redux:selectedTab'

function ReduxTab() {
  const [currentTabId, setTab] = useSessionPersistedTabs(tabIds, TAB_STORAGE_KEY)

  const currentTab = tabs.find(tab => tab.id === currentTabId)!
  const TabContent = currentTab.component

  return <HorizontalLayout>
    <Sidebar>
      {tabs.map(tab => (
        <MenuItem key={tab.id} onClick={setTab[tab.id]} title={tab.label} selected={tab.id === currentTabId} />
      ))}
    </Sidebar>

    <Content>
      <TabContent />
    </Content>
  </HorizontalLayout>
}

export default ReduxTab
